import React from "react";

import { getRegeneronCopayFormInitialValues } from "./form/initialValues";
import { SaveButton } from "../../header";
import useBaseEEConfiguration from "../../hooks/useBaseEEConfiguration";
import { applyTrimFields } from "../../utils/updateFormData";
import renderReactFromJson from "../../utils/renderReactFromJson";
import formJson from "./form/RegeneronCopayFormJson.json";
import { CompleteFormButton } from "../../CompleteFormButton";
import { HEADER_SUBMIT_BUTTON_TYPES } from "../../constants";
import { SignerTypes } from "../../../../../constant/ESign";
import moment from "moment-timezone";
import { DATE_FORMAT, dateFormatter } from "../../../../../utils/date";

export const useRegeneronCopayConfiguration = () => {
  const vendorName = "regeneron";
  const eePlanType = "copay";
  const rootPath = "application_form_editor.regeneron.copay"; //EE TODO: add data to src/locales/translations/en/ApplicationFormEditor.js
  const baseConfig = useBaseEEConfiguration({
    vendorName,
    eePlanType,
    rootPath,
    formJson
  });

  // EE TODO remove configuration that is not specific to the vendor and use the base configuration
  const regeneronSpecificConfig = {
    activeFormSection: "",
    getFormInitialValues: ({ applicationForm }) => getRegeneronCopayFormInitialValues({ applicationForm, formJson }),
    getFormFromJson: (form) => renderReactFromJson(form, formJson),
    saveButton: (props) => (
      <SaveButton
        showPdfOnSave={false}
        onSave={(form) => applyTrimFields(form)}
        id={"EE_regeneron_copay_save_form"}
        {...props}
      />
    ),
    afterSubmissionPayload: () => ({}),
    applicationFormHeaderSubmission: (props) => <CompleteFormButton id={"EE_complete_button"} {...props} />,
    headerSubmitButtonType: HEADER_SUBMIT_BUTTON_TYPES.GENERATE_PDF,
    shouldShowPdfInSecondStep: true,
    successMessage: (t, submittedDate, shouldAutoSubmit) =>
      t(
        !shouldAutoSubmit
          ? "patientApplications.enroll.application_form_submission.submit_completed"
          : "patientApplications.enroll.application_form_submission.auto_submit_succeeded",
        {
          submitDate: moment(submittedDate).format(DATE_FORMAT)
        }
      ),
    getSignatureWidgetSettingsBySignerType: (signerType) => {
      const signatureSettings = {
        [SignerTypes.PHYSICIAN]: {
          editable: true,
          titleTranslationKey: "patientApplications.enroll.electronic_signatures.signature_step.signers.physician",
          shouldShowCaregiverIndication: false,
          shouldUseRemoteRequestCheckboxes: false
        }
      };
      return signatureSettings[signerType];
    },
    shouldHaveSignatureAsTextLabel: true,
    shouldShowFileSize: true,
    submissionStep: {
      description: (t) => t("patientApplications.enroll.application_form_submission.eSign.description"),
      getSubmitButtonText: (t) => t("patientApplications.enroll.application_form_submission.submit_button"),
      submitModal: {
        showNotice: true,
        attachments: {
          showAllowedFileTypesNotice: true
        }
      },
      getSubmitSuccessMessage: (t) => t("patientApplications.enroll.application_form_submission.submit_success_message")
    },
    getEnrollResultData: ({ application }) => ({
      bin: application.bin,
      pcn: application.pcn,
      group: application.group,
      member_id: application.memberId,
      awarded_amount: application.awarded_amount,
      expiration_date: {
        value: dateFormatter(application.expiration_date),
        style: { marginTop: "25px" }
      }
    }),
    getAdditionalResultCardInformation: false,
    isUsingAsyncResponseLoader: true,
    hideAssociatedDrugs: true,
    contactSupportText: (t) => t("patientApplications.enroll.enroll_result.contact_time_regeneron")
  };
  return {
    ...baseConfig,
    ...regeneronSpecificConfig
  };
};

export default useRegeneronCopayConfiguration;
